import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectVerification = createSelector(
	(state: IStore) => state.verification,
	(verification) => verification
)
